import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { GlobalPrivateLayout } from '../../layouts/GlobalPrivateLayout';

const PrivateRoute_ = ({ component: Component, ...rest }) => {
  let auth = rest.autenticado;
  const idCountry = localStorage.getItem('country');

  localStorage.removeItem('country');

  if (auth) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <GlobalPrivateLayout>
            <Component {...props} />
          </GlobalPrivateLayout>
        )}
      />
    );
  } else {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/login',
              search: idCountry === 'COL' ? '?idCountry=COL' : '',
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }
};

const mapStateToProps = (state) => {
  return {
    autenticado: state.auth.autenticado,
  };
};
const mapDispatchToProps = null;

export const PrivateRoute = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute_);
